export default __webpack_public_path__ + "static/blake-cv-b2a0c97ea135160dbaff912d9980d718.png";